import { render, staticRenderFns } from "./LastOrdersWidget.vue?vue&type=template&id=1ebe616e&"
import script from "./LastOrdersWidget.vue?vue&type=script&lang=js&"
export * from "./LastOrdersWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports